// legalNewsReducer.js
import {
    FETCH_NEWS_REQUEST,
    FETCH_NEWS_SUCCESS,
    FETCH_NEWS_FAILURE,
    FETCH_CATEGORIES_REQUEST,
    FETCH_CATEGORIES_SUCCESS,
    FETCH_CATEGORIES_FAILURE,
    FETCH_NEWS_ITEM_REQUEST,
    FETCH_NEWS_ITEM_SUCCESS,
    FETCH_NEWS_ITEM_FAILURE,
    FETCH_BOOKMARKS_REQUEST,
    FETCH_BOOKMARKS_SUCCESS,
    FETCH_BOOKMARKS_FAILURE,
    ADD_BOOKMARK_REQUEST,
    ADD_BOOKMARK_SUCCESS,
    ADD_BOOKMARK_FAILURE,
    REMOVE_BOOKMARK_REQUEST,
    REMOVE_BOOKMARK_SUCCESS,
    REMOVE_BOOKMARK_FAILURE,
    FETCH_PREFERENCES_REQUEST,
    FETCH_PREFERENCES_SUCCESS,
    FETCH_PREFERENCES_FAILURE,
    UPDATE_PREFERENCES_REQUEST,
    UPDATE_PREFERENCES_SUCCESS,
    UPDATE_PREFERENCES_FAILURE,
    FETCH_RECOMMENDATIONS_REQUEST,
    FETCH_RECOMMENDATIONS_SUCCESS,
    FETCH_RECOMMENDATIONS_FAILURE,
    SET_CURRENT_CATEGORY,
    SET_SEARCH_TERM,
    FETCH_NEWS_COUNTRIES_REQUEST,
    FETCH_NEWS_COUNTRIES_SUCCESS,
    FETCH_NEWS_COUNTRIES_FAILURE,
    FETCH_NEWS_REGIONS_REQUEST,
    FETCH_NEWS_REGIONS_SUCCESS,
    FETCH_NEWS_REGIONS_FAILURE,
    SET_SELECTED_COUNTRIES,
    SET_SELECTED_REGION,
    SET_DETECTED_COUNTRY,
} from "../actions/types";

const initialState = {
    // News items
    news: [],
    totalNews: 0,
    newsItem: null,  // Will store the full news article with content
    categories: [],
    bookmarks: [],
    totalBookmarks: 0,
    recommendations: [],
    
    // User preferences
    preferences: {
        categories: [],
        keywords: [],
        countries: [],
        email_daily_digest: false,
        email_frequency: "daily",
        notification_enabled: true
    },
    
    // UI state
    currentCategory: null,
    searchTerm: "",

    // Country/region filters
    countries: [],
    regions: [],
    selectedCountries: [],
    selectedRegion: null,
    detectedCountry: null,

    // Loading and error states
    loading: {
        news: false,
        newsItem: false,
        categories: false,
        bookmarks: false,
        preferences: false,
        recommendations: false,
        addBookmark: false,
        removeBookmark: false,
        updatePreferences: false,
        countries: false,
        regions: false,
    },
    errors: {
        news: null,
        newsItem: null,
        categories: null,
        bookmarks: null,
        preferences: null,
        recommendations: null,
        addBookmark: null,
        removeBookmark: null,
        updatePreferences: null,
        countries: null,
        regions: null,
    }
};

const legalNewsReducer = (state = initialState, action) => {
    switch (action.type) {
        // News list fetching (without content)
        case FETCH_NEWS_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, news: true },
                errors: { ...state.errors, news: null }
            };
        case FETCH_NEWS_SUCCESS:
            return {
                ...state,
                news: action.payload.data,
                totalNews: action.payload.total,
                loading: { ...state.loading, news: false }
            };
        case FETCH_NEWS_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, news: false },
                errors: { ...state.errors, news: action.payload }
            };
            
        // Single news item fetching (with content)
        case FETCH_NEWS_ITEM_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, newsItem: true },
                errors: { ...state.errors, newsItem: null }
            };
        case FETCH_NEWS_ITEM_SUCCESS:
            return {
                ...state,
                newsItem: action.payload,
                loading: { ...state.loading, newsItem: false }
            };
        case FETCH_NEWS_ITEM_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, newsItem: false },
                errors: { ...state.errors, newsItem: action.payload }
            };
            
        // Categories fetching
        case FETCH_CATEGORIES_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, categories: true },
                errors: { ...state.errors, categories: null }
            };
        case FETCH_CATEGORIES_SUCCESS:
            return {
                ...state,
                categories: action.payload,
                loading: { ...state.loading, categories: false }
            };
        case FETCH_CATEGORIES_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, categories: false },
                errors: { ...state.errors, categories: action.payload }
            };
            
        // Bookmarks fetching
        case FETCH_BOOKMARKS_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, bookmarks: true },
                errors: { ...state.errors, bookmarks: null }
            };
        case FETCH_BOOKMARKS_SUCCESS:
            return {
                ...state,
                bookmarks: action.payload.data,
                totalBookmarks: action.payload.total,
                loading: { ...state.loading, bookmarks: false }
            };
        case FETCH_BOOKMARKS_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, bookmarks: false },
                errors: { ...state.errors, bookmarks: action.payload }
            };
            
        // Add bookmark
        case ADD_BOOKMARK_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, addBookmark: true },
                errors: { ...state.errors, addBookmark: null }
            };
        case ADD_BOOKMARK_SUCCESS:
            return {
                ...state,
                news: state.news.map(item => 
                    item.id === action.payload.news_id 
                        ? { ...item, is_bookmarked: true } 
                        : item
                ),
                newsItem: state.newsItem && state.newsItem.id === action.payload.news_id
                    ? { ...state.newsItem, is_bookmarked: true }
                    : state.newsItem,
                loading: { ...state.loading, addBookmark: false }
            };
        case ADD_BOOKMARK_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, addBookmark: false },
                errors: { ...state.errors, addBookmark: action.payload }
            };
            
        // Remove bookmark
        case REMOVE_BOOKMARK_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, removeBookmark: true },
                errors: { ...state.errors, removeBookmark: null }
            };
        case REMOVE_BOOKMARK_SUCCESS:
            return {
                ...state,
                news: state.news.map(item => 
                    item.id === action.payload 
                        ? { ...item, is_bookmarked: false } 
                        : item
                ),
                newsItem: state.newsItem && state.newsItem.id === action.payload
                    ? { ...state.newsItem, is_bookmarked: false }
                    : state.newsItem,
                bookmarks: state.bookmarks.filter(item => item.id !== action.payload),
                loading: { ...state.loading, removeBookmark: false }
            };
        case REMOVE_BOOKMARK_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, removeBookmark: false },
                errors: { ...state.errors, removeBookmark: action.payload }
            };
            
        // Preferences fetching
        case FETCH_PREFERENCES_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, preferences: true },
                errors: { ...state.errors, preferences: null }
            };
        case FETCH_PREFERENCES_SUCCESS:
            return {
                ...state,
                preferences: action.payload,
                loading: { ...state.loading, preferences: false }
            };
        case FETCH_PREFERENCES_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, preferences: false },
                errors: { ...state.errors, preferences: action.payload }
            };
            
        // Update preferences
        case UPDATE_PREFERENCES_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, updatePreferences: true },
                errors: { ...state.errors, updatePreferences: null }
            };
        case UPDATE_PREFERENCES_SUCCESS:
            return {
                ...state,
                preferences: action.payload,
                loading: { ...state.loading, updatePreferences: false }
            };
        case UPDATE_PREFERENCES_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, updatePreferences: false },
                errors: { ...state.errors, updatePreferences: action.payload }
            };
            
        // Recommendations fetching
        case FETCH_RECOMMENDATIONS_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, recommendations: true },
                errors: { ...state.errors, recommendations: null }
            };
        case FETCH_RECOMMENDATIONS_SUCCESS:
            return {
                ...state,
                recommendations: action.payload,
                loading: { ...state.loading, recommendations: false }
            };
        case FETCH_RECOMMENDATIONS_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, recommendations: false },
                errors: { ...state.errors, recommendations: action.payload }
            };
            
        // UI state
        case SET_CURRENT_CATEGORY:
            return {
                ...state,
                currentCategory: action.payload
            };
        case SET_SEARCH_TERM:
            return {
                ...state,
                searchTerm: action.payload
            };

        // Countries
        case FETCH_NEWS_COUNTRIES_REQUEST:
            return { ...state, loading: { ...state.loading, countries: true }, errors: { ...state.errors, countries: null } };
        case FETCH_NEWS_COUNTRIES_SUCCESS:
            return { ...state, countries: action.payload, loading: { ...state.loading, countries: false } };
        case FETCH_NEWS_COUNTRIES_FAILURE:
            return { ...state, loading: { ...state.loading, countries: false }, errors: { ...state.errors, countries: action.payload } };

        // Regions
        case FETCH_NEWS_REGIONS_REQUEST:
            return { ...state, loading: { ...state.loading, regions: true }, errors: { ...state.errors, regions: null } };
        case FETCH_NEWS_REGIONS_SUCCESS:
            return { ...state, regions: action.payload, loading: { ...state.loading, regions: false } };
        case FETCH_NEWS_REGIONS_FAILURE:
            return { ...state, loading: { ...state.loading, regions: false }, errors: { ...state.errors, regions: action.payload } };

        // Country/region selection
        case SET_SELECTED_COUNTRIES:
            return { ...state, selectedCountries: action.payload };
        case SET_SELECTED_REGION:
            return { ...state, selectedRegion: action.payload };
        case SET_DETECTED_COUNTRY:
            return { ...state, detectedCountry: action.payload };

        default:
            return state;
    }
};

export default legalNewsReducer;